import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { SelfDiagnosticStepModel } from './model';
import { SelfDiagnosticStepState } from './state';
import * as selectors from './selectors';
import * as actions from './actions';

@Injectable()
export class SelfDiagnosticStepFacade {
  private store = inject<Store<SelfDiagnosticStepState>>(Store);

  //public getById(id: number) {
  //  return this.store.pipe(select(selectors.selectById(id)))
  //}

  public getStep(serviceId: number, page: number) {
    this.store.dispatch(new actions.GetStepRequestAction(serviceId, page));
  }

  public getSelected(): Observable<SelfDiagnosticStepModel> {
    return this.store.pipe(select(selectors.selectSelected));
  }

  public setSelected(model: SelfDiagnosticStepModel) {
    this.store.dispatch(new actions.SetSelectedRequestAction(model));
  }

  public getError(): Observable<any> {
    return this.store.pipe(select(selectors.selectError));
  }

  public isLoading(): Observable<boolean> {
    return this.store.pipe(select(selectors.selectIsLoading));
  }
}
